export function clambersSignature(word: string): string {
  return [...word].sort().join('');
}

// Supplied locally as the canonical set of unambiguous six-letter Clambers answers.
// Keep the words lowercase and one per line so updates remain auditable.
const CLAMBERS_WORD_DATA = `
health
should
policy
number
public
member
before
county
access
change
movies
author
canada
market
forums
better
memory
august
always
groups
making
future
london
become
format
months
safety
having
common
living
window
france
update
either
europe
videos
global
lyrics
submit
though
thanks
weight
beauty
friday
annual
google
church
figure
enough
higher
yellow
french
growth
income
needed
effect
sunday
volume
anyone
supply
robert
skills
middle
taking
object
length
follow
levels
letter
degree
button
female
spring
police
wanted
unique
survey
mexico
paypal
valley
larger
strong
budget
amazon
useful
indian
dating
behind
buying
string
unless
moving
brands
pretty
boston
medium
awards
studio
device
theory
visual
jersey
driver
campus
museum
bottom
switch
weekly
square
module
giving
chance
vision
accept
highly
appear
actual
coffee
closed
league
effort
kansas
doctor
reduce
flight
pocket
errors
worked
myself
expert
saying
branch
column
plants
avenue
viewed
attack
placed
dollar
played
shirts
sexual
hawaii
adults
script
dakota
looked
forgot
dallas
bought
broken
alaska
equity
sounds
forced
austin
injury
joseph
toward
finish
brazil
famous
writer
gender
junior
ticket
manner
matrix
turkey
proper
colors
happen
luxury
frames
mostly
taylor
hidden
bureau
sydney
stress
fourth
census
poetry
forget
newest
extent
sweden
backup
expand
affect
hosted
anyway
crafts
filled
cables
cotton
killed
debate
starts
comedy
jewish
howard
safari
formal
showed
winner
oxford
mirror
kernel
stocks
greece
behalf
liquid
saving
twenty
avatar
helped
powers
heaven
blocks
paying
crisis
bright
stands
poland
upload
voting
smooth
narrow
labels
deluxe
fabric
visits
berlin
caught
bottle
rubber
legend
brings
commit
jacket
excess
stamps
mining
garage
thongs
cheese
fellow
hilton
horror
ethnic
taught
prefer
toyota
shaved
syntax
filing
shadow
clinic
korean
packet
funded
dublin
nelson
murder
digest
arthur
verify
copper
nobody
cloudy
wealth
vacuum
essays
fairly
config
stupid
harbor
puzzle
troops
broker
deputy
loaded
johnny
facing
trembl
legacy
hybrid
bigger
exceed
babies
compaq
slowly
infant
unlike
wright
proven
cached
comply
cherry
webcam
quebec
socket
wisdom
payday
philip
knight
cooper
basics
struct
wizard
morris
eminem
picked
bikini
ottawa
diving
invite
terror
thirty
victim
murray
oxygen
cookie
passes
durham
gloves
flickr
rivers
thumbs
twelve
decade
titten
drinks
voices
albany
coding
hiking
arabia
panama
judges
walked
norton
locked
fusion
canvas
nurses
bishop
pulled
floral
worlds
guilty
moscow
pixels
totals
afford
herbal
deemed
headed
murphy
thinks
tongue
monkey
approx
engage
quoted
proved
butter
pepper
weapon
autumn
packed
timely
talked
brooks
newton
whilst
prompt
ebooks
victor
divine
shield
prague
pickup
nascar
lambda
belong
rabbit
frozen
yamaha
hebrew
gained
adjust
guided
powell
jeremy
hardly
hoping
bubble
scroll
beaver
kijiji
hiring
clocks
surely
stylus
tribal
meetup
cycles
detect
techno
celtic
boxing
watson
strict
hourly
thehun
uganda
adidas
harvey
hazard
fruits
suzuki
exempt
refuse
superb
floors
speaks
burton
mixing
fitted
zambia
genome
honors
fallen
sussex
backed
msgstr
adipex
prizes
pursue
lonely
hereby
collar
kelkoo
finite
nasdaq
tuning
gotten
rocket
bullet
duncan
locale
hammer
runner
arctic
zoning
mighty
galaxy
newbie
belize
jungle
andrea
bailey
eugene
metric
joshua
assign
tigers
aurora
rhythm
sudden
speeds
vocals
chubby
cowboy
queens
defeat
clicks
harper
tenant
tattoo
freely
remedy
surrey
solved
magnet
cayman
jaguar
gothic
graphs
divide
barrel
typing
floppy
makeup
wicked
pushed
enzyme
zshops
tackle
favors
sticks
excuse
strand
cheque
reject
settle
scenic
munich
celebs
pillow
harley
finals
flavor
hungry
thrown
helmet
accent
eleven
auburn
unlock
pledge
merger
nextel
kruger
granny
fleece
wiring
calvin
bumper
garlic
banned
mumbai
tariff
marvel
petite
gossip
deadly
baking
sticky
heated
jackie
brutal
yields
blacks
vertex
tomato
valves
bufing
velvet
wesley
slovak
beside
fought
pencil
freeze
italia
gently
fridge
blades
advert
subaru
picnic
hollow
travis
colony
cannon
forbes
cooked
cement
violin
modems
prozac
impose
willow
barbie
michel
virtue
adware
zoloft
ultram
viking
newman
asylum
robbie
poison
`;

export const CLAMBERS_ANSWERS = CLAMBERS_WORD_DATA.trim().split(/\s+/);
export const CLAMBERS_ACCEPTED_WORDS = [...CLAMBERS_ANSWERS];
export const CLAMBERS_ACCEPTED_SET: ReadonlySet<string> = new Set(CLAMBERS_ACCEPTED_WORDS);
export const CLAMBERS_WORD_GROUPS = CLAMBERS_ANSWERS.map((word) => [word]);

export const CLAMBERS_ANAGRAM_INDEX = new Map<string, string[]>();
for (const word of CLAMBERS_ACCEPTED_WORDS) {
  const signature = clambersSignature(word);
  const group = CLAMBERS_ANAGRAM_INDEX.get(signature) ?? [];
  group.push(word);
  CLAMBERS_ANAGRAM_INDEX.set(signature, group);
}
